export default __webpack_public_path__ + "static/media/ps_business_logo.d3ed2fbe.svg";